import { ButtonStatusVariant } from '../../../../../components/ButtonWithFeddback';
import LangEnum from '../../../../../lang/LangEnum';
import { TranslateType } from '../../../../translation/translationContext.types';
import { Catalog } from '../../../catalog.types';

export type ExportCatalogImageModelOption = {
  value: ExportImageModel;
  label: LangEnum;
  subtitle: LangEnum;
};

export enum ExportType {
  PDF = 'PDF',
  XLSX = 'XLSX',
}

export enum ExportMethod {
  EMAIL = 'EMAIL',
  DOWNLOAD = 'DOWNLOAD',
}

export enum ExportQuality {
  HIGH = 'HIGH',
  LOW = 'LOW',
}

export enum ExportImageModel {
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export type OnSubmitCatalogModal = {
  values: ExportFormValues;
  isAdminSeller?: boolean;
  messages: {
    onSuccessMessage: string;
    onErrorMessage: string;
  };
};

export type OpenCatalogModal = {
  catalog: Catalog;
  activeFilters?: Record<string, string | string[]>;
  initialClassificationTypeId?: string;
};

export type ExportFormValues = {
  exportType: ExportType;
  exportMethod: ExportMethod;
  exportQuality: ExportQuality;
  exportImageModel: ExportImageModel;
  priceTableId?: string;
  classificationTypeId?: string;
};

export type CatalogModalStoreTypes = {
  isModalOpen: boolean;
  catalog: Catalog | null;
  activeFilters: Record<string, string | string[]> | null;
  initialClassificationTypeId: string | null;
  isLoading: boolean;
  buttonStatus: ButtonStatusVariant;
  openModal: (params: OpenCatalogModal) => void;
  closeModal: () => void;
  setIsLoading: (value: boolean) => void;
  onSubmit: (params: OnSubmitCatalogModal) => Promise<void>;
  reset: () => void;
};

export type ExportImageModelSelectProps = {
  exportImageModel: ExportImageModel;
  handleChangeImageModel: (value: ExportImageModel) => void;
};

export interface UseCatalogExportModalParams {
  isLoading: boolean;
  isAdminSeller: boolean;
  isModalOpen: boolean;
  translate: TranslateType;
  initialClassificationTypeId: string | null;
  onSubmit: (params: OnSubmitCatalogModal) => Promise<void>;
}
